import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  styled,
  Typography,
} from '@material-ui/core'
import { AuthContext } from 'context'
import { uploadExcelService } from 'lib'
import React, { ChangeEvent } from 'react'

const UploadExcelPage = () => {
  const { user } = React.useContext(AuthContext)

  const [file, setFile] = React.useState<File | null>(null)
  const [loading, setLoading] = React.useState<boolean>(false)
  const [isOpenDialog, setIsOpenDialog] = React.useState(false)

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  })

  const openDialog = () => {
    setIsOpenDialog(true)
  }

  const closeDialog = () => {
    setIsOpenDialog(false)
    setFile(null)
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    const existsFiles = files && files.length > 0
    const existsUserId = user?.userId
    if (existsFiles && existsUserId) {
      uploadExcel(files![0], user?.userId!)
    }
  }

  const uploadExcel = async (newFile: File, userId: number) => {
    setLoading(true)
    try {
      const result = await uploadExcelService(newFile, userId)
      if (result) {
        setFile(newFile)
        openDialog()
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Box py={2}>
        <Typography
          style={{
            fontWeight: 700,
            fontSize: '0.875rem',
            letterSpacing: '0.5px',
            lineHeight: 1.43,
            color: 'rgba(0, 0, 0, 0.54)',
          }}
        >
          {'Subir reporte de pagos'}
        </Typography>
      </Box>

      <Box py={2} width={'100%'} style={{ display: 'flex', justifyContent: 'center' }}>
        {file && (
          <Box>
            <Box
              p={2}
              width={162}
              border={'1px dashed rgba(0, 0, 0, 0.2)'}
              style={{ display: 'flex', gap: 4 }}
            >
              <Icon>{'article'}</Icon>
              <Typography>{file.name}</Typography>
            </Box>
          </Box>
        )}

        {!file && (
          <Box>
            <Button
              tabIndex={-1}
              role={undefined}
              component={'label'}
              variant={'contained'}
              size={'small'}
              color={'primary'}
              disabled={loading}
              startIcon={<Icon>{'file_upload'}</Icon>}
            >
              {'Subir excel'}
              <VisuallyHiddenInput
                type={'file'}
                accept={'.xls, .xlsx'}
                onChange={handleFileChange}
              />
            </Button>
          </Box>
        )}
      </Box>

      <Dialog
        open={isOpenDialog}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'Archivo cargado con éxito'}</DialogTitle>
        <DialogContent>
          <DialogContentText id={'alert-dialog-description'}>
            {`El archivo ${file?.name} se ha subido y procesado correctamente.`}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeDialog}>{'Cerrar'}</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default UploadExcelPage
